export const ROOT = 'common/account';

export const HASH_ACCOUNT_REQUEST = `${ROOT}/HASH_ACCOUNT_REQUEST`;
export const HASH_ACCOUNT_FAILURE = `${ROOT}/HASH_ACCOUNT_FAILURE`;
export const HASH_ACCOUNT_SUCCESS = `${ROOT}/HASH_ACCOUNT_SUCCESS`;
